import { getStore } from '../store/store';
import { checkUniqueCalendar, dedupeArrayValues } from 'owa-selected-calendars-utils';

export function getSelectedCalendars() {
    return dedupeArrayValues(getStore().selectedCalendars, checkUniqueCalendar);
}
